export const sendRequest = <T>(url: string, method: string, body: object): Promise<T> => {
  const options: RequestInit = {
    method,
    headers: {
      'Content-type': 'application/json',
      'x-auth-token': localStorage.authToken,
    },
    body: JSON.stringify(body),
  };

  return fetch(url, options).then((response) => {
    if (response.ok) {
      return response.json();
    }

    return Promise.reject(new Error(response.statusText));
  });
};
